import { createFileRoute } from '@tanstack/react-router';
import { McpLandingPage } from '@/components/astro/new-design-25/mcp/mcp-landing-page';
import * as m from '@/paraglide/messages';
import { seo } from '@/seo/seo';

export const Route = createFileRoute('/_marketing/mcp')({
  head: () => ({
    meta: [
      ...seo({
        title: m.mcp_meta_title(),
        description: m.mcp_meta_description(),
      }),
    ],
  }),
  component: McpLandingPage,
});
